import { submittedAt } from "src/lib/submission";
import type { QueueEntry } from "src/api/types";

interface Props {
  entry: QueueEntry;
}

export function SubmissionChecks({ entry }: Props) {
  const items = [
    { label: "Insurance card", done: submittedAt(entry.insurance_card_submitted_at) },
    { label: "Consents", done: submittedAt(entry.consents_submitted_at) },
  ].filter((item) => item.done);

  if (items.length === 0) return null;

  return (
    <span className="submission-checks">
      {items.map((item) => (
        <span key={item.label} className="submission-check">
          <span className="submission-check-mark" aria-hidden="true">
            ✓
          </span>
          {item.label}
          <span className="visually-hidden"> submitted</span>
        </span>
      ))}
    </span>
  );
}
